import { render, staticRenderFns } from "./BaseModalConfirm.vue?vue&type=template&id=06ff9e1e&scoped=true&"
import script from "./BaseModalConfirm.vue?vue&type=script&lang=js&"
export * from "./BaseModalConfirm.vue?vue&type=script&lang=js&"
import style0 from "./BaseModalConfirm.vue?vue&type=style&index=0&id=06ff9e1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ff9e1e",
  null
  
)

export default component.exports